{
  "name": "AgreementConfiguration",
  "columns": [
    {
      "fieldName": "priority",
      "displayName": "Priority",
      "dataType": "STRING"
    },
    {
      "fieldName": "description",
      "displayName": "Description",
      "dataType": "STRING"
    },
    {
      "fieldName": "criteria.rules",
      "displayName": "Criteria",
      "dataType": "ARRAY",
      "thStyleConfig": {
        "width": "300px"
      },
      "styleConfig": {
        "type": "multi-tag"
      }
    }
  ],
  "actions":[
    {
      "fieldName": "status",
      "displayName": "",
      "dataType": "STRING",
      "thStyleConfig": {
        "width": "140px"
      },
      "styleConfig": {
        "type": "action",
        "icon": "assets/icons/configure.svg",
        "iconStyleProperties": {
          "background": "var(--brand-600)"
        },
        "styleProperties": {
          "display": "flex",
          "gap": "4px",
          "alignItems": "center",
          "background": "transparent",
          "color": "#1062B9",
          "fontSize": "14px",
          "fontStyle": "normal",
          "border": "none",
          "fontWeight": 500,
          "lineHeight": "20px"
        },
        "actionConfig": {
          "label": "Configure",
          "actionName":"configure",
          "writeOperation": false
        }
      }
    },
    {
      "fieldName": "status",
      "displayName": "",
      "dataType": "STRING",
      "styleConfig": {
        "type": "action",
        "icon": "assets/icons/pencil_icon.svg",
        "iconStyleProperties": {
          "background": "var(--gray-700)"
        },
        "styleProperties": {
          "border-radius": "8px",
          "background": "transparent",
          "border": "none"
        },
        "actionConfig": {
          "label": "",
          "actionName":"edit",
          "writeOperation": false
        }
      }
    },
    {
      "fieldName": "clone",
      "displayName": "",
      "dataType": "STRING",
      "styleConfig": {
        "type": "action",
        "icon": "assets/icons/clone_icon.svg",
        "iconStyleProperties": {
          "background": "var(--gray-700)"
        },
        "styleProperties": {
          "border-radius": "8px",
          "background": "transparent",
          "border": "none"
        },
        "actionConfig": {
          "label": "",
          "actionName":"clone",
          "writeOperation": false
        }
      }
    },
    {
      "fieldName": "status",
      "displayName": "",
      "dataType": "STRING",
      "styleConfig": {
        "type": "action",
        "icon": "assets/icons/delete_icon.svg",
        "iconStyleProperties": {
          "background": "var(--error-600)"
        },
        "styleProperties": {
          "border-radius": "8px",
          "background": "transparent",
          "border": "none"
        },
        "actionConfig": {
          "label": "",
          "actionName":"delete",
          "writeOperation": false
        }
      }
    }
  ]
}
